// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"89752d8f","626":"95b55707"}[chunkId] + ".chunk.js";
};